import { ModalSteps, StepInfo } from '@components/shared/modal-steps.component.tsx';
import { Steps } from './company-company-profile-modal.component';

interface CompanyEditNavBarProps {
  stepsInfo: StepInfo[];
  isEdit: boolean;
  handleStepClick: (step: Steps) => void;
}

export const CompanyEditNavBar: React.FC<CompanyEditNavBarProps> = ({ stepsInfo, isEdit, handleStepClick }) => {
  const filteredSteps = stepsInfo.filter((step) => (isEdit && step.step !== Steps.TEAM) || !isEdit);

  return (
    <ModalSteps
      stepsInfo={filteredSteps}
      onStepClick={handleStepClick}
    />
  );
};
